import { FC, ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { useAppSelector } from "@/store";

interface IPrivateRoute {
  component: ReactNode;
  navLink: string;
}

const PrivateRoute: FC<IPrivateRoute> = ({
  component: Component,
  navLink,
  ...rest
}): ReactElement => {
  const { user } = useAppSelector((state) => state.auth);

  if (user) {
    return Component ? (
      <Component {...rest} />
    ) : (
      <Navigate to={navLink} replace />
    );
  }

  return <Navigate to="/login" replace />;
};

export default PrivateRoute;
